import { CheckedFormsValidity } from '@core/data-access/models/form/form-validity.model';
import { filter, keys, reduce, sortBy } from 'lodash';
import { FormValidities, OrderedStepValidities, StepValidities } from '../step.interface';

export const getLastEnabledPage = (orderedStepValidities: OrderedStepValidities) =>
  orderedStepValidities
    .slice(0)
    .reverse()
    .find(({ value: { disabled, visible, showInStepNavigation } }) => !disabled && visible && showInStepNavigation);

export const setStepFormValidities = (
  checkedFormsValidity: CheckedFormsValidity,
  shouldInvalidateCurrentStep: boolean
): FormValidities =>
  reduce(
    checkedFormsValidity,
    (formValidities, formValidity, formName) => {
      formValidities[formName] = !shouldInvalidateCurrentStep ? formValidity.isValid : false;

      return formValidities;
    },
    {} as FormValidities
  );

export const setTicketAssignmentStepFormsValidities = (
  checkedFormsValidity: CheckedFormsValidity,
  areAllTicketAssignmentStepFormsValidAndValidationIsNotProcessing: boolean,
  shouldInvalidateCurrentStep: boolean
) =>
  reduce(
    checkedFormsValidity,
    (formValidities, formValidity, formName) => {
      formValidities[formName] = !shouldInvalidateCurrentStep
        ? formValidity.isValid && areAllTicketAssignmentStepFormsValidAndValidationIsNotProcessing
        : false;

      return formValidities;
    },
    {} as FormValidities
  );

export const getSortedVisibleStepValidities = (stepValidities: StepValidities) =>
  filter(
    sortBy(keys(stepValidities), (step) => stepValidities[step].order),
    (step) => stepValidities[step].visible
  );
